// extracted by mini-css-extract-plugin
export default {"container":"HomePage_container__ONGTf","banner":"HomePage_banner__WgTYt"};